@if (user$ | async; as user) {
  <app-user-logo class="new-data-user-avatar" [userId]="userId"></app-user-logo>
  @if (searchable) {
    <p searchableText class="text-navy-90">{{ getUserFullName(user) }}</p>
  }
  @if (!searchable) {
    <div class="text-navy-90">{{ getUserFullName(user) }}</div>
  }
}
